import React from "react";
import styled from "styled-components";
import { space, SpaceProps, typography, TypographyProps } from "styled-system";

const TdWrapper = styled.td`
  ${typography};
  ${space};
`;

export const Td: React.FC<TypographyProps & SpaceProps> = ({ children, ...props }) => <TdWrapper {...props}>{children}</TdWrapper>;
